import AutomationManager from "../automation/AutomationManager";
import BaseAutomation from "../automation/BaseAutomation";
import PrestigeAutomation from "../automation/PrestigeAutomation";
import BigNumSave from "./BigNumSave";

export default class AutomationSave {
    constructor() {        
    }

    /**
     * @param {AutomationManager} automationManager
     * @returns {Object}
     */
    static generateSave(automationManager) {
        const saveState = {};

        saveState.prevTurn = automationManager.prevTurn;

        saveState.minedAutomation = this.generateAutomationSave(automationManager.minedUpgradeAutomation);
        saveState.pickAutomation = this.generateAutomationSave(automationManager.pickUpgradeAutomation);
        saveState.prestigeAutomation = this.generatePrestigeAutomationSave(automationManager.prestigeAutomation);

        return saveState;
    }

    /**
     * @param {AutomationManager} automationManager
     * @param {Object} saveState 
     */
    static loadSave(automationManager, saveState) {
        if (!saveState) {
            return;
        }
        
        automationManager.prevTurn = saveState.prevTurn;

        this.loadAutomationSave(automationManager.minedUpgradeAutomation, saveState.minedAutomation);
        this.loadAutomationSave(automationManager.pickUpgradeAutomation, saveState.pickAutomation);
        this.loadPrestigeAutomationSave(automationManager.prestigeAutomation, saveState.prestigeAutomation);
    }

    /**
     * @private
     * @param {BaseAutomation} automation 
     * @returns {Object}
     */
    static generateAutomationSave(automation) {
        const saveState = {};

        saveState.lastAutomationTurn = automation.lastAutomationTurn;
        saveState.lastAutomationFrame = automation.lastAutomationFrame;
        saveState.active = automation.active;

        return saveState;
    }

    /**
     * @private
     * @param {BaseAutomation} automation 
     * @param {Object} saveState 
     */
    static loadAutomationSave(automation, saveState) {
        if (!saveState) {
            return;
        }

        automation.lastAutomationTurn = saveState.lastAutomationTurn;
        if (saveState.lastAutomationFrame) {
            automation.lastAutomationFrame = saveState.lastAutomationFrame;
        }

        automation.active = saveState.active;
    }

    /**
     * @private
     * @param {PrestigeAutomation} automation 
     * @returns {Object}
     */
    static generatePrestigeAutomationSave(automation) {
        const saveState = this.generateAutomationSave(automation);

        saveState.prevUnclaimedPrestige = BigNumSave.save(automation.prevUnclaimedPrestige);

        return saveState;
    }

    /**
     * @private
     * @param {PrestigeAutomation} automation 
     * @param {Object} saveState 
     */
    static loadPrestigeAutomationSave(automation, saveState) {
        if (!saveState) {
            return;
        }

        this.loadAutomationSave(automation, saveState);

        if (saveState.prevUnclaimedPrestige) {
            BigNumSave.load(saveState.prevUnclaimedPrestige, automation.prevUnclaimedPrestige);
        }
    }
}